
import { Component, Vue } from 'vue-property-decorator'
import NumberedCardSection from '@/components/NumberedCardSection.vue'
import InfoBlock from './components/InfoBlock.vue'
import CommentBlock from './components/CommentBlock.vue'
import walletData from './googleWalletData.json'

@Component({ components: { NumberedCardSection, InfoBlock, CommentBlock } })
export default class GoogleWallet extends Vue {
  readonly cards = walletData.cards
  readonly steps = walletData.steps
  readonly cases = walletData.cases
}
